import NoResults from 'fe-design-base/assets/illustrations/NoResults';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';

const EmptyState = () => (
  <Box mt={48} p={12} tcenter flex column gap={12}>
    <Box alignSelfCenter>
      <NoResults h={48} w={48} />
    </Box>
    <Box tcenter pt={16}>
      <Text
        color="mono700"
        variant="heading3"
        i18n="requests_feed.empty_team.title"
      />
    </Box>
    <Box tcenter>
      <Text color="mono700" i18n="requests_feed.empty_team.desc" />
    </Box>
  </Box>
);

export default EmptyState;
